<template>
    <BasePopover
        :disabled="!formButtonDisabled || !!loading"
        size="sm"
        position="bottom-right">
        <template #trigger>
            <div>
                <BaseButton
                    size="sm"
                    class="text-left"
                    :disabled="formButtonDisabled"
                    @click="emits('add')">
                    <span v-if="loading === form.id">
                        <LoadingSpinner />
                    </span>
                    <span v-else>
                        <span class="text-xs font-light text-gray-600">{{ $t('forms.types.' + form.type) }}</span><br>
                        {{ form.name }}
                    </span>
                </BaseButton>
            </div>
        </template>
        <div>
            <Icon
                name="heroicons:no-symbol-16-solid"
                class="text-danger-500 mr-2" />
            <span v-if="cannotCreateEvent">
                {{ $t('forms.cannotCreateEvent') }}
            </span>
            <span v-else-if="cannotCreateProcess">
                {{ $t('forms.cannotCreateProcess') }}
            </span>
            <span v-else-if="noMultipleOccurrencesInEvent">
                {{ $t('forms.noMultipleOccurrencesInEvent') }}
            </span>
            <span v-else-if="noMultipleOccurrenceInProcess">
                {{ $t('forms.noMultipleOccurrenceInProcess') }}
            </span>
            <span v-else>
                {{ $t('forms.cannotAddForm') }}
            </span>
        </div>
    </BasePopover>
</template>

<script setup>
import {useSlideOverStore} from "@/store/slideOver"

const slideOverStore = useSlideOverStore()
const {t: $t} = useI18n()

const props = defineProps({
    form: {
        type: Object,
        required: true,
    },
    fundingProgram: {
        type: Object,
        required: true,
    },
    loading: {
        type: Number,
        default: 0
    }
})

const emits = defineEmits(['add'])

const formButtonDisabled = computed(() => {
    return props.loading === props.form.id || cannotCreateProcess.value || noMultipleOccurrenceInProcess.value || cannotCreateEvent.value || noMultipleOccurrencesInEvent.value
})

const cannotCreateEvent = computed(() => {
    return slideOverStore.context == null && !props.form.can_create_new_event
})

const noMultipleOccurrencesInEvent = computed(() => {
    const existingForms = slideOverStore.context?.data?.processes?.some(process => {
        if (process.status.marks_process_aborted) return false

        return process.form_processes?.some(formProcess => {
            return formProcess.formable.id === props.form.id
        })
    })

    return slideOverStore.context?.type === 'event' && existingForms && !props.form.multiple_occurrence_in_event
})

const cannotCreateProcess = computed(() => {
    return slideOverStore.context?.type !== 'process' && !props.form.can_create_new_process
})

const noMultipleOccurrenceInProcess = computed(() => {
    return slideOverStore.context?.type === 'process' &&
        (slideOverStore.context?.data?.formProcesses?.some(formProcess => formProcess.form.id === props.form.id) ||
            slideOverStore.context?.data?.form_processes?.some(formProcess => formProcess.formable.id === props.form.id)) &&
        !props.form.multiple_occurrence_in_process
})
</script>
